export default {"src":"/_next/static/media/stak.70b0d2ba.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};